import React from "react";
import styles from "./PayrollTab.module.css";

const PayrollTable = ({ payrolls }) => {
  if (!payrolls.length) return <div className={styles.empty}>لا يوجد سجل مرتبات لهذا الموظف</div>;

  return (
    <div className={styles.tableWrapper}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>الفترة</th><th>الراتب الأساسي</th><th>العمولة</th>
            <th>المكافأة</th><th>الخصومات</th><th>الصافي</th><th>تاريخ الصرف</th>
          </tr>
        </thead>
        <tbody>
          {payrolls.map((p) => (
            <tr key={p.id}>
              <td>{new Date(p.period).toLocaleDateString("ar-EG", { month: "long", year: "numeric" })}</td>
              <td>{p.baseSalary?.toLocaleString()} ج.م</td>
              <td>{p.commissionAmount?.toLocaleString()} ج.م</td>
              <td>{p.bonusAmount?.toLocaleString()} ج.م</td>
              <td className={styles.deduction}>-{p.deductionAmount?.toLocaleString()} ج.م</td>
              <td className={styles.netSalary}>{p.netSalary?.toLocaleString()} ج.م</td>
              <td>{new Date(p.paymentDate).toLocaleDateString("ar-EG")}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PayrollTable;